import { useState } from "react";
import { MenuItem, Select, Button, Input, Grid2 } from "@mui/material";
import { _ACTIONS, _COLORS } from "../../utils/constants";
import { _ROUTES } from "../../utils/_routes_constants";
import { createToast } from "../../utils/toast";
import { getCookie } from "../../utils/cookieHelper";

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [directoryChoosen, setDirectoryChoosen] = useState("accounting_files");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      createToast("error", "No file selected");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("directory", directoryChoosen);

    // Retrieve and validate the token
    const tmp = getCookie("token");
    const token = tmp ? tmp : null;
    if (!token) {
      createToast("error", "JWT Token not found");
      return;
    }

    const fileResponse = await fetch(
      `${process.env.REACT_APP_API_URL + _ROUTES.UPLOAD}`,
      {
        method: _ACTIONS.POST,
        headers: {
          // Ne pas définir "Content-Type" pour FormData
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      },
    )
      .then((response) => {
        if (!response.ok) {
          createToast("error", "File upload failed");
        } else {
          createToast("success", "File uploaded successfully");
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        createToast("error", "An error occurred while uploading the file");
      });
  };

  return (
<form onSubmit={handleSubmit}>
  <Grid2 container spacing={2} sx={{ marginBottom: 2, flexDirection: "row", alignItems: "center" }}>
    <Select
      size="small"
      variant="outlined"
      value={directoryChoosen}
      onChange={(e) => {
        setDirectoryChoosen(e.target.value);
      }}
      id="directory"
      name="directory"
      sx={{ width: "30%", marginRight: 2 }}
    >
      <MenuItem value="" selected>
        Select a type of file
      </MenuItem>
      <MenuItem value="accounting_files">Accounting Files</MenuItem>
      <MenuItem value="boulders">Boulders</MenuItem>
      <MenuItem value="sales">Sales</MenuItem>
    </Select>
    <Input 
      type="file" 
      onChange={handleFileChange} 
      sx={{ width: "40%", marginRight: 2 }} 
      inputProps={{ accept: ".csv" }}
    />
    <Button
      variant="contained"
      sx={{ backgroundColor: _COLORS.lightBlue }}
      onClick={handleSubmit}
      type="submit"
    >
      Upload
    </Button>
  </Grid2>
</form>
  );
};

export default FileUpload;
